import {addI18Keysets} from '../../../../i18n';

import dicts from './dicts';

export default addI18Keysets('yt:system-actions', dicts);
